<div class="row justify-content-center">
  <div class="col-12 col-lg-10 col-xl-8">

    <!-- Header -->
    <app-organization-header></app-organization-header>

    <!-- Form -->
    <form [formGroup]="form">

      <div class="alert alert-warning" role="alert">
        Pour le moment, il n'est pas possible de changer le nom de votre entreprise vous-mêmes.Nous travaillons à
        rajouter cette fonctionnalité prochainement. En attendant, vous pouvez nous contacter en utilisant l'icône de
        clavardage en bas à droite de la page.
      </div>

      <app-alert-messages></app-alert-messages>

      <div class="row">
        <div class="col-12 col-md-6">
          <!-- First name -->
          <magieno-input-text-field [advancedFormControl]="name"></magieno-input-text-field>
        </div>
      </div> <!-- / .row -->

      <!-- Button -->
      <!--            <magieno-button [button]="form.getButton('SAVE')"></magieno-button>-->

    </form>

    <br><br>

  </div>
</div> <!-- / .row -->